<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="
    isVisibleDetailForm || isVisibleSocialMediaDetailForm ? 'd-none' : ''
  "
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
  (onRefresh)="onReset()"
>
  <!--------------------------------------- Audit btns ---------------------------------------->
  <div class="card-toolbar" after-btns>
    <!-- back btn -->
    <a
      type="button"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.back' | translate"
      (click)="onClose()"
    >
      <i class="mdi mdi-arrow-left mdi-20px tw-p-0"></i>
    </a>
  </div>

  <!-------------------------------------- Table Content ----------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- minPrice -->
        <td>
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.minPrice"
          ></td-value>
        </td>

        <!-- maxPrice -->
        <td>
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.maxPrice"
          ></td-value>
        </td>

        <!-- mtnSmartPercent -->
        <td class="tw-py-2">
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.mtnSmartPercent"
          ></td-value>
          <span class="2px">%</span>
        </td>

        <!-- mciSmartPercent -->
        <td class="tw-py-2">
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.mciSmartPercent"
          ></td-value>
          <span class="2px">%</span>
        </td>

        <!-- rightelSmartPercent -->
        <td class="tw-py-2">
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.rightelSmartPercent"
          ></td-value>
          <span class="2px">%</span>
        </td>

        <!-- description -->
        <td class="large-text">
          <span> {{ item?.description | checkValue }}</span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!-- isDefault -->
        <td>
          <td-value type="boolean" [value]="item?.isDefault"></td-value>
        </td>
        <!-------------------------------- operations ------------------------------->
        <td class="sticky-td">
          <a mat-icon-button [matMenuTriggerFor]="menu">
            <i class="mdi mdi-dots-vertical text-navyBlue mdi-20px"></i>
          </a>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div
              mat-menu-item
              class="tw-flex-center text-navyBlue border-bottom"
              (click)="onUpdate(item.id, false)"
            >
              <i
                class="mdi mdi-pencil-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.edit" | translate
              }}</span>
            </div>

            <!-- detail button -->
            <div
              mat-menu-item
              class="tw-flex-center text-info border-bottom"
              (click)="getDetailsById(item.id)"
            >
              <i
                class="mdi mdi-text-box-search-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-info"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.detail" | translate
              }}</span>
            </div>

            <!-- detail button -->
            <div
              mat-menu-item
              class="tw-flex-center text-info border-bottom"
              (click)="getMediaDetailById(item.id)"
            >
              <i
                class="mdi mdi-text-box-search-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-info"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.mediaDetail" | translate
              }}</span>
            </div>

            <!-- delete button -->
            <div
              mat-menu-item
              class="tw-flex-center text-danger"
              (click)="onDelete(item.id, item.title)"
            >
              <i
                class="mdi mdi-trash-can-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-danger"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.delete" | translate
              }}</span>
            </div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-group-price-form
    [isSuperAdmin]="userSession?.isSuperAdmin()"
    [title]="formPageConfig.title"
    [formPageConfig]="formPageConfig"
    [categoryId]="categoryId"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-group-price-form>
</ng-container>

<!-- group price details -->
<ng-container *ngIf="isVisibleDetailForm">
  <app-group-price-details-form
    [formPageConfig]="formDetailPageConfig"
    (closeFormPage)="closeDetails()"
    [tagName]="tagName"
  >
  </app-group-price-details-form>
</ng-container>

<!-- group price media details -->
<ng-container *ngIf="isVisibleSocialMediaDetailForm">
  <app-group-price-social-media-detail-form
    [formPageConfig]="formSocialMediaDetailPageConfig"
    (closeFormPage)="closeDetails()"
    [tagName]="tagName"
  >
  </app-group-price-social-media-detail-form>
</ng-container>

<!--Group Price Audit -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    methodName="groupPricesGetGroupPricesAudit"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!---------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    menuTitle="GroupPrices"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!--Group Price Detail Audit -->
<!-- <ng-container *ngIf="showDetailAuditPage">
  <app-audit [service]="groupPriceDetail" methodName="groupPriceDetailsGetGroupPriceDetailsAudit"
    (hidePage)="onHideGroupPriceDetailAuditPage()">
  </app-audit>
</ng-container> -->
